import {ElementLink} from '@acng/frontend-stargazer';
import {TIME} from '@acng/frontend-bounty/dom/element.js';
import {DATETIME, get} from '@acng/frontend-bounty/dom/attribute.js';
import {guard, STRING} from '@acng/frontend-rubicon';
import {user} from '../../user/user.js';

/**
 * ## Stargazer DOM Element
 *
 * | Phase   | Description                              |
 * | ------- | ---------------------------------------- |
 * | Upgrade | Set `textContent` to a localized string. |
 *
 * @group DOM Element
 */
const name = TIME;

ElementLink(name, (element) => {
  const datetime = get(element, DATETIME);
  ASSERT: guard(datetime, STRING, `<${name}> ${DATETIME} attribute`);

  element.textContent = new Date(datetime).toLocaleString(user.lang, {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
});

export {name as TIME};
